import { buildEmailMap, matchByEmail, emailLocalPart } from './emailMatch.js';

const API_BASE = import.meta.env.VITE_API_BASE_URL;

// Deltek/Vantagepoint uses the shared cross-domain email matcher. Names kept
// for existing callers/tests; they delegate to emailMatch.
export { emailLocalPart };
export const buildDeltekMap = buildEmailMap;
export const matchDeltek = matchByEmail;

// Returns a Map usable with matchDeltek() for O(1) cross-domain merge lookups.
export async function getDeltekEmployees(token) {
  if (!API_BASE) return new Map();

  try {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const res = await fetch(`${API_BASE}/deltek/employees`, { headers });
    if (!res.ok) throw new Error(`Deltek API ${res.status}`);

    const employees = await res.json();
    return buildEmailMap(employees);
  } catch (err) {
    console.warn('Deltek fetch failed (non-fatal):', err.message);
    return new Map();
  }
}
